const ITEMS = [
  "TUBING",
  "DRILL PIPE",
  "TOOL INSPECTION",
  "BLACKLIGHT",
  "CLEANING & COATING",
  "WATER BLASTING",
  "STORAGE",
  "TRUCKING",
];

function Track({ ariaHidden }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="text-outline whitespace-nowrap px-8 font-display text-6xl font-semibold uppercase tracking-tight sm:text-7xl lg:text-8xl">
            {item}
          </span>
          <span className="h-3 w-3 rotate-45 bg-uv/70" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      className="relative overflow-hidden border-y border-white/10 bg-steel py-10 sm:py-14"
      data-testid="services-marquee"
      aria-label="Services: tubing, drill pipe, tool inspection, blacklight, cleaning and coating, water blasting, storage, trucking"
    >
      <div className="marquee-track flex w-max">
        <Track ariaHidden={false} />
        <Track ariaHidden={true} />
      </div>
    </section>
  );
}
